import { PRODUCT_NAMES } from './product-names.js';
/** Customer-facing form field labels (DB columns like `beaconId` stay unchanged). */
export const NODE_ID_LABEL = 'Node ID';
export const ACTIVE_NODE_LABEL = 'Active Node';
export const NO_NODE_LINKED_MESSAGE = 'No Node linked to this container';
/** Spatial tables and panels (API fields like `tagId` stay unchanged). */
export const NODE_ASSET_COLUMN_LABEL = 'Node / Asset';
export const NODES_PLURAL_LABEL = `${PRODUCT_NAMES.NODE}s`;
export const SATELLITES_PLURAL_LABEL = `${PRODUCT_NAMES.SATELLITE}s`;
export const SEARCH_NODES_PLACEHOLDER = `Search ${NODE_ID_LABEL}…`;
export const SEARCH_SATELLITES_PLACEHOLDER = `Search ${PRODUCT_NAMES.SATELLITE}s…`;
export const SUPPORT_VIEWER_DESCRIPTION = `Read-only view of live ${PRODUCT_NAMES.NODE} and ${PRODUCT_NAMES.SATELLITE} state for CCI Spatial deployments.`;
export function formatNodeIdCaption(nodeId) {
    return `${PRODUCT_NAMES.NODE} · ${nodeId}`;
}
export function nodesTabLabel(count) {
    return `${NODES_PLURAL_LABEL} (${count})`;
}
export function satellitesTabLabel(count) {
    return `${SATELLITES_PLURAL_LABEL} (${count})`;
}
/** Compact Axon lock chrome (banners, chips, dialogs). */
export const AXON_LOCK_LABEL = `${PRODUCT_NAMES.AXON} lock`;
export const AXON_LOCK_BANNER_TITLE = 'AXON LOCKED';
/** Fleet registration for Nodes / Satellites (`vendorDeviceId`). */
export const POSITIONING_DEVICE_ID_LABEL = 'Positioning Device ID';
export const POSITIONING_DEVICE_ID_HELPER = 'ID reported by the positioning engine (e.g. last 5 chars of MAC for Woxu)';
//# sourceMappingURL=terminology.js.map